<template>
  <div class="alert">
    <span class="closebtn" @click="$emit('close')">×</span>
    <strong>Errore!</strong>

    <template v-if="errorMessages">
      <ul v-for="(errorMessage, index) in errorMessages" :key="index">
        <li>{{ errorMessage }}</li>
      </ul>
    </template>
    <span v-else>Impossibile completare la richiesta, provare a ricaricare la pagina</span>
  </div>
</template>

<script>
export default {
  name: 'error',
  props: ['errorMessages'],
};
</script>

<style lang="scss" scoped>
.alert {
  padding: 20px;
  background-color: #f44336;
  color: white;
  opacity: 0.83;
  transition: opacity 0.6s;
  margin-bottom: 15px;
}
.closebtn {
  padding-left: 15px;
  color: white;
  font-weight: bold;
  float: right;
  font-size: 20px;
  line-height: 18px;
  cursor: pointer;
  transition: 0.3s;
}
</style>
